module.exports = __webpack_public_path__ + "static/media/security-icon@2x.f675dcc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/security-icon@2x.png
// module id = 291
// module chunks = 0